class GiftWithPurchase {
  constructor() {
    this.giftVariantId = 56666961740100;
    this.thresholdCents = 2500;
    this.isUpdating = false;

    this.init();
  }

  init() {
    document.addEventListener('DOMContentLoaded', () => {
      this.syncGift();
    });

    document.addEventListener('cart:refresh', () => {
      this.syncGift();
    });
  }

  async syncGift() {
    if (this.isUpdating) return;

    try {
      const cart = await this.fetchCart();

      const giftLine = this.findGiftLine(cart);
      const qualifyingSubtotal = this.getQualifyingSubtotal(cart);
      const qualifies = qualifyingSubtotal >= this.thresholdCents;

      console.log('[Gift] status', {
        giftVariantId: this.giftVariantId,
        qualifyingSubtotal,
        thresholdCents: this.thresholdCents,
        qualifies,
        giftLine,
      });

      if (qualifies && !giftLine) {
        await this.addGift();
        return;
      }

      if (!qualifies && giftLine) {
        await this.removeGift(giftLine.key);
        return;
      }

      if (giftLine && giftLine.quantity !== 1) {
        await this.setGiftQuantity(giftLine.key, 1);
        return;
      }
    } catch (error) {
      console.error('[Gift] sync failed', error);
    }
  }

  async fetchCart() {
    const response = await fetch('/cart.js', { cache: 'no-store' });
    if (!response.ok) throw new Error('Failed to fetch cart');
    return response.json();
  }

  findGiftLine(cart) {
    return (cart.items || []).find((item) => Number(item.variant_id) === this.giftVariantId);
  }

  getQualifyingSubtotal(cart) {
    return (cart.items || []).reduce((sum, item) => {
      if (Number(item.variant_id) === this.giftVariantId) return sum;
      return sum + Number(item.original_line_price || 0);
    }, 0);
  }

  async addGift() {
    this.isUpdating = true;

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          items: [
            {
              id: this.giftVariantId,
              quantity: 1,
              properties: {
                _auto_gift: 'true',
              },
            },
          ],
        }),
      });

      const data = await response.json();
      console.log('[Gift] addGift response', response.status, data);

      if (!response.ok) {
        throw new Error('Failed to add gift');
      }

      await this.refreshCartSections();
    } finally {
      this.isUpdating = false;
    }
  }

  async removeGift(lineKey) {
    this.isUpdating = true;

    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          id: lineKey,
          quantity: 0,
        }),
      });

      const data = await response.json();
      console.log('[Gift] removeGift response', response.status, data);

      if (!response.ok) {
        throw new Error('Failed to remove gift');
      }

      await this.refreshCartSections();
    } finally {
      this.isUpdating = false;
    }
  }

  async setGiftQuantity(lineKey, quantity) {
    this.isUpdating = true;

    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          id: lineKey,
          quantity,
        }),
      });

      const data = await response.json();
      console.log('[Gift] setGiftQuantity response', response.status, data);

      if (!response.ok) {
        throw new Error('Failed to normalize gift quantity');
      }

      await this.refreshCartSections();
    } finally {
      this.isUpdating = false;
    }
  }

  async refreshCartSections() {
  const mainCartItems = document.getElementById('main-cart-items');

  if (mainCartItems) {
    await this.refreshMainCartItems();
  }

  if (window.freeShippingBar) {
    window.freeShippingBar.refresh();
  }
}

  async refreshMainCartItems() {
    const response = await fetch(`${routes.cart_url}?section_id=main-cart-items`, {
      cache: 'no-store',
    });
    const htmlText = await response.text();
    const html = new DOMParser().parseFromString(htmlText, 'text/html');
    const source = html.querySelector('#main-cart-items .js-contents');
    const target = document.querySelector('#main-cart-items .js-contents');

    if (source && target) {
      target.innerHTML = source.innerHTML;
    }
  }
}

window.giftWithPurchase = new GiftWithPurchase();